import { useFeatureFlagEnabled } from '@posthog/react';
import customIcons from '../../utils/icons';
import { useCampaignsEnabled } from '../organisation-settings/organisationSettingsProvider';
import { MenuItem } from '../../types/global';
import Role, { FeatureFlags, householdDataViewerRoles } from '../../types/enums';
import useAuth from '../../utils/auth';

export default function useMainMenuConfig(): MenuItem[] {
  const { campaignsEnabled } = useCampaignsEnabled();
  const authUser = useAuth();

  const isFileExchangeEnabled = useFeatureFlagEnabled(FeatureFlags.fileExchangeEnabled) || false;
  const isOutcomeTrackerEnabled = useFeatureFlagEnabled(FeatureFlags.outcomeTrackerEnabled) || false;
  const hasHouseholdLevelAccess: boolean = householdDataViewerRoles.includes(authUser.role satisfies Role);

  return [
    {
      name: 'Summary', icon: customIcons.homeIcon, path: '/', enabled: true,
    },
    {
      name: 'Campaigns', icon: customIcons.sendIcon, path: '/campaigns', enabled: campaignsEnabled,
    },
    {
      name: 'Street View', icon: customIcons.mapIcon, path: '/streetview', enabled: true,
    },
    {
      name: 'Benefit take-up', icon: customIcons.coins, path: '/benefit-take-up', enabled: true,
    },
    {
      name: 'Debt', icon: customIcons.creditCard, path: '/debt', enabled: true,
    },
    ...(isFileExchangeEnabled ? [{
      name: 'File Exchange', icon: customIcons.fileUp, path: '/file-exchange', enabled: true,
    }] : []),
    ...(isOutcomeTrackerEnabled ? [{
      name: 'Outcome Tracker', icon: customIcons.clipboard, path: '/outcome-tracker', enabled: hasHouseholdLevelAccess
      ,
    }] : []),
  ];
}
